export const RC_ComponentSlides = require('./rc-git-it-done').default;
export const CCC_ComponentSlides = require('./ccc-git-it-done').default;
export const KCDC_ComponentSlides = require('./kcdc-git-it-done').default;

export default {
  RC_ComponentSlides,
  KCDC_ComponentSlides,
  CCC_ComponentSlides,
};



// WEBPACK FOOTER //
// ./src/presentations/git-more-done/index.js